"use client";

import React from "react";
import { TriangleAlert, UserX, EyeOff, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const challenges = [{
  title: "Back & Neck Pain",
  description: "Expert chiropractic care to resolve chronic discomfort, spinal misalignments, and posture-related strain for lasting physical relief.",
  icon: TriangleAlert
}, {
  title: "Sciatica & Nerve Issues",
  description: "Targeted treatments designed to relieve pressure on the nervous system, restoring sensation and function to your lower body.",
  icon: UserX
}, {
  title: "Headaches & Migraines",
  description: "Holistic approaches to tension and vascular headaches, addressing root causes to help you find clarity and daily comfort.",
  icon: EyeOff
}, {
  title: "Sports & Joint Injuries",
  description: "Comprehensive recovery plans to optimize performance and accelerate healing for athletes and active individuals across Cyprus.",
  icon: TrendingUp
}];
export default function EfficiencyCeilingAnalysis() {
  const {
    headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="111184" id="conditions-we-resolve" className="py-24 bg-[#F8F8F6] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-[#1A1A2E] mb-4 tracking-tight">
            Conditions We Resolve
          </h2>
          <p className="text-lg font-sans text-[#4A5568] tracking-tight">
            Personalized, professional care for the complex physical needs of our Cyprus community.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {challenges.map((challenge, i) => {
          const Icon = challenge.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100} ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full border-[#E2E8F0] shadow-sm hover:shadow-xl hover:bg-[#3B8FD4] transition-all duration-300 bg-white group rounded-2xl">
                  <CardHeader className="pb-2">
                    <div className="w-12 h-12 rounded-full bg-[#3B8FD4]/10 flex items-center justify-center mb-4 text-[#3B8FD4] group-hover:bg-white/20 group-hover:text-white transition-colors duration-300">
                      <Icon className="w-6 h-6" />
                    </div>
                    <CardTitle className="text-xl font-serif font-medium text-[#1A1A2E] tracking-tight group-hover:text-white transition-colors duration-300">
                      {challenge.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-base font-sans text-[#4A5568] tracking-tight leading-relaxed group-hover:text-white/90 transition-colors duration-300">
                      {challenge.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}